import { Button } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { TbPlus } from "react-icons/tb";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";
import { useNotificationActions } from "@/stores/use-notification-table";

import { ReadAllNotificationButton } from "./list/NotificationHeader";

/**
 * Panel wrapper for notification pages with header actions.
 * Includes "Mark All as Read" and "Create Notification" buttons in the header.
 */
function NotificationPanel({ children }: { children: ReactNode }) {
    const { t } = useTranslation();

    return (
        <Panel
            title={
                <PanelTitle title={t("notifications")}>
                    <div className="col-span-12 md:col-span-6 flex items-center justify-end gap-2">
                        <ReadAllNotificationButton variant="outlined" size="medium" />
                        <CreatenotificationButton />
                    </div>
                </PanelTitle>
            }
        >
            {children}
        </Panel>
    );
}

/**
 * Button to create a new notification. Currently placeholder.
 */
function CreatenotificationButton() {
    const { t } = useTranslation();
    const { updateShowCreateNotificationDialog } = useNotificationActions();

    return (
        <Button
            className=" grow-0 shrink-0"
            variant="contained"
            onClick={() => updateShowCreateNotificationDialog(true)}
            startIcon={<TbPlus />}
        >
            {t("buttons.newNotification")}
        </Button>
    );
}
export default NotificationPanel;
